import React from 'react'
import ArrowLeft from '#src/components/Header/StandardHeader/icons/arrow-left.svg'
import styles from './styles.css'

interface MenuHeaderProps {
  onBack?: () => void
  header?: string
  testId?: string
}

const MenuHeader: React.FC<MenuHeaderProps> = ({ onBack, header, testId }) => {
  return (
    <div className={styles.header} onClick={() => onBack && onBack()} data-testid={testId}>
      {onBack && (
        <button className={styles.back}>
          <ArrowLeft />
        </button>
      )}
      <span className={styles.headerLabel}>{header || 'Go back'}</span>
    </div>
  )
}

export default MenuHeader
